import { RequestService } from '../../../../../common/services/RequestService';
import { GET_ALL_ORDERS } from '../constants';
import { dataAdjustmentResponse } from './dataAdjustmentResponse';

export const getAllOrdersRequest = async profileId => {
  const response = await RequestService.get(
    GET_ALL_ORDERS.replace('{profile_id}', profileId)
  );
  return (
    response.data &&
    Array.isArray(response.data) &&
    response.data.map(document => dataAdjustmentResponse(document))
  );
};
